// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_E-r","cls2":"SimplePaperPodcast-cls2_uS7 SimplePaperPodcast-cls1_E-r"};